<cs-header>
  <cs-header-title>{{ LL.coach.awaiting.headerTitle() }}</cs-header-title>
</cs-header>

<cs-content>
  <div class="awaiting-coach-content">
    @if (logoUrl) {
      <img class="brand-logo" [src]="logoUrl" alt="" />
    }
    <cs-icon name="hourglass"></cs-icon>
    @if (brandName) {
      <div class="brand-name">{{ brandName }}</div>
    }
    <div class="awaiting-title">{{ LL.coach.awaiting.title() }}</div>
    @if (coachName) {
      <div class="awaiting-subtext">{{ LL.coach.awaiting.subtextWithCoach({ coachName: coachName }) }}</div>
    } @else {
      <div class="awaiting-subtext">{{ LL.coach.awaiting.subtext() }}</div>
    }
  </div>
</cs-content>
